// extracted by mini-css-extract-plugin
export default {"mediaWrapper":"mediaWrapper__Cbqzl","mediaOverlay":"mediaOverlay__rB5JI","mediaOverlayContentWrapper":"mediaOverlayContentWrapper__jooNG","caption":"caption__PRoq2","paginator":"paginator__JvBMg","foe":"foe__aYGpG","mediaContentBox":"mediaContentBox__JGSN0","mediaContentBorder":"mediaContentBorder__ShikP","mediaContentLogo":"mediaContentLogo___Cs1B","clear":"clear__eCAgZ","slide":"slide__PnBDL","contentButtonExit":"contentButtonExit__bSzsX","contentButtonLeft":"contentButtonLeft__NrOTK","contentButtonRight":"contentButtonRight__pWJmg","mediaContent":"mediaContent__fXyl7"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"mediaWrapper\":\"mediaWrapper__Cbqzl\",\"mediaOverlay\":\"mediaOverlay__rB5JI\",\"mediaOverlayContentWrapper\":\"mediaOverlayContentWrapper__jooNG\",\"caption\":\"caption__PRoq2\",\"paginator\":\"paginator__JvBMg\",\"foe\":\"foe__aYGpG\",\"mediaContentBox\":\"mediaContentBox__JGSN0\",\"mediaContentBorder\":\"mediaContentBorder__ShikP\",\"mediaContentLogo\":\"mediaContentLogo___Cs1B\",\"clear\":\"clear__eCAgZ\",\"slide\":\"slide__PnBDL\",\"contentButtonExit\":\"contentButtonExit__bSzsX\",\"contentButtonLeft\":\"contentButtonLeft__NrOTK\",\"contentButtonRight\":\"contentButtonRight__pWJmg\",\"mediaContent\":\"mediaContent__fXyl7\"}";
        // 1787130556878
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  